import { render, staticRenderFns } from "./FreightModal.vue?vue&type=template&id=b79ff89c&"
import script from "./FreightModal.vue?vue&type=script&lang=js&"
export * from "./FreightModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports